import React from 'react';

function Navigation(){
    return(
      <nav id="ASUNavMenu">
      <div className="container">
      
        <div id="block-tb-megamenu-main-menu" className="block block-tb-megamenu">
          <div className="content">
            <div className="tb-megamenu tb-megamenu-main-menu">
              <button data-target=".nav-collapse" data-toggle="collapse" className="btn btn-navbar tb-megamenu-button menuIstance-processed" type="button">
                <i className="fa fa-reorder"></i>
              </button>
              <div className="nav-collapse always-show">
                <ul className="tb-megamenu-nav nav level-0 items-14">
                  <li data-id="703" data-level="1" data-type="menu_item" data-class="" data-xicon="" data-caption="" data-alignsub="" data-group="0" data-hidewcol="0" data-hidesub="0" className="active tb-megamenu-item level-1 mega">
                    <a href="/" title="Home">
                      <span className="fa fa-home icon-white">
                        <span style={{display: 'none'}}>Home</span>
                      </span>
                    </a>
                  </li>
                  {/*
                  <li data-id="648" data-level="1" data-type="menu_item" data-class="" data-xicon="" data-caption="" data-alignsub="" data-group="0" data-hidewcol="0" data-hidesub="0" className="tb-megamenu-item level-1 mega">
                    <a href="#" title="News/Events"> Campuses </a>
                  </li>
                  */}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
    );
}

export default Navigation;
